export class RestoreMicrosoft365UserByEntityRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<Microsoft365UserRestoreWorkload>",
            "format": ""
        },
        {
            "name": "targetSaasEntityId",
            "baseName": "targetSaasEntityId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365UserByEntityRequest.attributeTypeMap;
    }
    constructor() {
    }
}
